import React from 'react';

interface Props {
  content: string;
}

export const FormSubLabel = ({ content }: Props) => {
  return <p className="my-2.5">{content}</p>;
};
